'use strict';

var sdAnalyticsService = function ($log, $http) {

    var enable = true;
    var guid;
    var providerName = this.providerName;
    var sd = window.sd;
    var appId = 'OSS UI';
    var dfxEventsCollectorServerUrl = _.get(window.appSettings, 'shiftDigitalDfxEventsCollectorServerUrl', 'https://ipvu4r2qd2.execute-api.us-east-1.amazonaws.com/v1');

    this.init = function () {
        guid = guidGenerator();
        if (!providerName || !sd) enable = false;
    }

    this.resetSession = function () {
        guid = guidGenerator();
    }

    this.sendScheduleServiceImpression = function () {
        sendEvent('scheduleServiceImpression');
    }

    this.sendScheduleServiceStart = function () {
        sendEvent('scheduleServiceStart');
    }

    this.sendScheduleServiceLogin = function () {
        sendEvent('scheduleServiceLogin');
    }

    var serviceTypeMap = {
        'factoryRequired': 'frs',
        'customerConcerns': 'repair',
        'dealerRecommended': 'drs',
        'recallsUpdates': 'recall'
    }

    this.sendScheduleServiceAccountCreated = function () {
        sendEvent('scheduleServiceAccountCreated');
    }

    this.sendServiceScheduleApptSet = function (vehicle, mileage, services) {

        var eventServices = _.flatMap(services, function (items, key) {
            return _.map(items, function (s) {
                return {title: s.name, category: serviceTypeMap[key], msrp: s.analyticsMsrp};
            })
        })

        var data = {
            serviceVehicleYear: vehicle.year.name,
            serviceVehicleMake: vehicle.make.name,
            serviceVehicleModel: vehicle.model.name,
            serviceVehicleVin: vehicle.vin,
            serviceVehicleMileage: mileage
        };

        sendEvent('scheduleServiceApptSet',
            _.assign(_.clone(data), {services: eventServices}), // ShiftDigital data
            _.assign(_.clone(data), {TotalMsrp: _.sumBy(eventServices, 'msrp')}) // DFX data
        );
    }

    function sendEvent(name, sdData, dfxData) {
        sendEventToSD(name, sdData);
        sendEventToDFX(name, dfxData);
    }

    function sendEventToSD(eventName, data) {
        if (!enable || !sd) return;

        data = _.defaults(data, {
            scheduleServiceSessionId: guid,
            scheduleServiceProvider: providerName,
            events: eventName
        });

        sd('dataLayer', data, true);
        sd('send');
    }

    function sendEventToDFX(eventName, payload) {
        if (!enable || !dfxEventsCollectorServerUrl) return;

        var data = {
            SessionId: guid,
            AppId: appId,
            DealerId: parseInt(_.get(window, 'appSettings.currentDealerId', -1)),
            EventName: eventName,
            EventLocalDate: moment().format('YYYY-MM-DD'),
            EventLocalDateTime: moment().format('HH:mm:ss.SSS'),
            EventPayload: payload || {}
        };

        return $http({
            url: dfxEventsCollectorServerUrl,
            method: 'POST',
            data: data,
            params: '',
            headers: {
                'Content-Type': 'application/xml'
            },
            ignoreErrors: true
        })
    }

    function guidGenerator() {
        var u = Date.now().toString(16) + Math.random().toString(16) + '0'.repeat(16);
        return [u.substr(0, 8), u.substr(8, 4), '4000-8' + u.substr(13, 3), u.substr(16, 12)].join('-');
    }

    return this;
};

sdAnalyticsService.$inject = ['$log', '$http'];

var sdAnalyticsServiceProvider = function () {
    this.providerName;
    this.setProviderName = function (value) {
        this.providerName = value;
    }
    this.$get = sdAnalyticsService;
};

module.exports = sdAnalyticsServiceProvider;
